export default "__VITE_ASSET__a106868f__"